import { motion } from 'framer-motion';
import { cloneElement, isValidElement, useState, type ReactElement } from 'react';
import { findIntegracaoPreset } from '../features/IntegracaoPage/IntegracaoPresets';

interface boxProps {
	plataforma: string;
	image: string;
	index?: number;
}

type IconeProps = { width?: number; height?: number; className?: string };

const IntegracaoBox = ({ plataforma, image, index = 0 }: boxProps) => {
	const [falhou, setFalhou] = useState(false);
	const delay = index * 0.05;
	const semImagem = !image || falhou;
	const icone = semImagem ? findIntegracaoPreset(plataforma)?.icon : undefined;

	if (semImagem && !isValidElement(icone)) return null;

	return (
		<motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay }} className="border border-gray-200 rounded-lg size-7 flex items-center justify-center">
			{icone && isValidElement(icone) ? (
				cloneElement(icone as ReactElement<IconeProps>, { width: 14, height: 14, className: 'size-3.5' })
			) : (
				<img alt={plataforma} className="w-3.5" src={image} onError={() => setFalhou(true)} />
			)}
		</motion.div>
	);
};

export default IntegracaoBox;
